var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.1373,
    y: 2.98047,
    width: 18.6667,
    height: 30.6667,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1937 13.32L23.3112 13.3212C21.835 13.3212 21.5487 14.0225 21.5487 15.0513V17.3213H25.07L24.6112 20.8775H21.5487V30H17.8775V20.8775H14.8075V17.3213H17.8775V14.7C17.8775 11.6562 19.7362 10 22.45 10C23.75 10 24.8675 10.0962 25.1937 10.14V13.32ZM20 0C8.955 0 0 8.95375 0 20C0 31.045 8.955 40 20 40C31.0462 40 40 31.045 40 20C40 8.95375 31.0462 0 20 0Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0bd406e6867158589537bb49da9e0eb7.svg";
export { ForwardRef as ReactComponent };